import { render, staticRenderFns } from "./allblack2.vue?vue&type=template&id=41b9423a&scoped=true&"
import script from "./allblack2.vue?vue&type=script&lang=js&"
export * from "./allblack2.vue?vue&type=script&lang=js&"
import style0 from "./allblack2.vue?vue&type=style&index=0&id=41b9423a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b9423a",
  null
  
)

export default component.exports